import { showTargetItems } from '@/pages/opinion/pages/accounts/constants';
import { dealwithAccountChannelInfo } from '../../render-helper';
import { initialUpperCase } from '@/pages/opinion/utils';

export default function accountMetricsTableColumns(params: any) {
  let hasDOD = params.downloadDOD;
  let isAccount = params.model_type === 'account';

  let commonColumns: any = [
    {
      render: 'name',
      header: 'Channel',
      renderHelper: [dealwithAccountChannelInfo('channel', params, isAccount)],
    },
  ];

  if (isAccount) {
    commonColumns.push({
      render: 'name',
      header: 'Account',
      renderHelper: [dealwithAccountChannelInfo('name', params, isAccount)],
    });
  }

  showTargetItems.forEach((key) => {
    const title = initialUpperCase(key);
    commonColumns.push({
      render: key,
      header: title,
    });
    if (hasDOD) {
      commonColumns.push({
        render: key + '_than',
        header: title + ' Change%',
        renderHelper: [
          (item: { [x: string]: number }, key: string | number) =>
            item[key] / 100,
        ],
        numFmt: '0.00%',
      });
    }
  });

  return commonColumns;
}
